module.exports = __webpack_public_path__ + "fonts/highs-and-lows-sid-icon.svg";